import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Icon } from "@/components/common/Icon";
import { Reveal, SectionHeading } from "@/components/common/Reveal";
import { PageHero, CtaBand } from "@/components/site/PageHero";
import { CATEGORIES, SCOPES } from "@/data/products";
import { IMAGES } from "@/data/site";
import { SearchPanel } from "@/components/catalog/ProductSearch";

const CatalogTile = ({ c, i }) => (
  <Link to={`/solutions/${c.slug}`} className="card-base group flex h-full flex-col overflow-hidden" data-testid={`solution-card-${c.slug}`}>
    <div className="relative flex h-52 items-center justify-center bg-white p-6">
      <img src={c.products[0].image} alt={c.name} loading="lazy" className="h-full object-contain mix-blend-multiply transition-transform duration-500 group-hover:scale-105" />
      <span className="mono absolute left-4 top-4 text-[11px] text-slate-400">{String(i + 1).padStart(2, "0")}</span>
      <span className="absolute right-4 top-4 rounded-full bg-[#F4F6F2] px-2.5 py-0.5 text-[11px] font-semibold text-slate-600">{c.products.length} products</span>
    </div>
    <div className="flex flex-1 flex-col border-t border-slate-100 p-6">
      <Icon name={c.icon} className="h-5 w-5" style={{ color: c.accent }} />
      <h3 className="mt-3 text-lg text-slate-900">{c.name}</h3>
      <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{c.short}</p>
      <span className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-[#C20500]">View catalogue <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></span>
    </div>
  </Link>
);

export function Solutions() {
  return (
    <div data-testid="solutions-page">
      <PageHero eyebrow="Solutions" title="Fire safety products & engineered systems." text={`${CATEGORIES.length} product categories across two clear scopes: supply & wall-mount, and electrical & low-voltage installation (wiring only).`} image={IMAGES.atrium} />
      <section className="container-x pb-6 pt-20" data-testid="catalog-section">
        <SectionHeading eyebrow="Product catalogue" title="Search or browse by scope" text="Specs, applications and FAQs for every product. Tap Get a quote on any product for pricing." />
        <div className="mt-8 max-w-3xl"><SearchPanel grid testid="solutions-search" /></div>
      </section>
      {Object.entries(SCOPES).map(([key, s], si) => (
        <section key={key} className={`py-16 ${si ? "bg-[#F4F6F2]" : ""}`} data-testid={`scope-section-${key}`}>
          <div className="container-x">
            <div className="border-l-4 border-[#C20500] pl-5">
              <p className="eyebrow">Scope 0{si + 1}</p>
              <h2 className="mt-2 text-2xl text-slate-900 sm:text-3xl">{s.label}{key === "wiring" ? " (wiring only)" : ""}</h2>
              <p className="mt-2 max-w-2xl text-sm text-slate-600">{s.text}</p>
            </div>
            <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
              {CATEGORIES.filter((c) => c.scope === key).map((c, i) => <Reveal key={c.slug} delay={(i % 4) * 0.05}><CatalogTile c={c} i={CATEGORIES.indexOf(c)} /></Reveal>)}
            </div>
          </div>
        </section>
      ))}
      <CtaBand />
    </div>
  );
}
